export enum IntegrationLookupTableEnum {
    BjcDivisionMappings = 'nurses.Client.BJCDivisionMapping'
}

export enum IntegrationLookupTableRequestEnum {
    'nurses.Client.BJCDivisionMapping' = 'bjc/division-mappings'
}
